// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var FailedSolid = function FailedSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.571 1A2.574 2.574 0 0 0 1 3.571V16.43A2.574 2.574 0 0 0 3.571 19H16.43A2.574 2.574 0 0 0 19 16.429V3.57A2.574 2.574 0 0 0 16.429 1zm3.175 5.746a.96.96 0 0 1 1.362 0l1.888 1.888 1.888-1.888a.964.964 0 0 1 1.362 1.362l-1.888 1.888 1.888 1.888a.964.964 0 0 1-1.362 1.362l-1.888-1.888-1.888 1.888a.964.964 0 0 1-1.362-1.362l1.888-1.888-1.888-1.888a.96.96 0 0 1 0-1.362"
  }));
};
